<script>
    import SearchBar from '$lib/components/SearchBar.svelte';
    import { t } from '$lib/i18n.js';
</script>

<section id="search">
    <div class="bg-container">
        <div class="bg"></div>
    </div>
    <img src="https://assets.auting.it/images/draws/home-header.svg" alt="Home Header Draw" decoding="sync" fetchpriority="high" loading="eager" />
    <div class="content">
        <h1>{$t('routes.home.header.title')}</h1>
        <p>{$t('routes.home.header.description')}</p>
        <SearchBar />
        <div class="row">
            <p>{$t('routes.home.header.project_insured_by')}</p>
            <img class="reale-mutua-logo" src="https://assets.auting.it/images/reale-mutua/black.png" alt="Reale Mutua Logo" />
        </div>
    </div>
</section>

<style>
    section {
        aspect-ratio: 1500 / 850;
        width: 100vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .bg-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        z-index: -1;
        padding-bottom: 80px;
    }

    .bg-container .bg {
        background: #5EAFE5;
        background: -webkit-linear-gradient(180deg, rgba(94, 175, 229, 1) 0%, rgba(124, 208, 214, 1) 100%);
        background: -moz-linear-gradient(180deg, rgba(94, 175, 229, 1) 0%, rgba(124, 208, 214, 1) 100%);
        background: linear-gradient(180deg, rgba(94, 175, 229, 1) 0%, rgba(124, 208, 214, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5EAFE5", endColorstr="#7CD0D6", GradientType=0);
        width: 100vw;
        height: 100%;
        object-fit: cover;
        object-position: bottom;
    }

    section div.content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        max-width: 1200px;
        width: 100%;
        padding-top: 100px;
    }

    section img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        object-fit: cover;
        object-position: bottom;
    }

    section div.content {
        padding-bottom: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }

    h1 {
        color: var(--on-primary);
        margin: 0;
        padding: 0;
    }

    p {
        color: var(--on-primary-75);
        margin: 0;
        padding: 0;
        text-align: center;
        z-index: 2;
    }

    .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: var(--on-primary-75);
        margin-top: 0px;
    }

    .reale-mutua-logo {
            height: 24px;
            width: 72px;
            object-fit: contain;
            position: relative;
            filter: invert(100%) brightness(200%);
            margin-bottom: 6px;
    }

    @media (max-width: 768px) {
        section {
            aspect-ratio: auto;
            height: auto;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
        }

        .content {
            padding-top: 150px;
        }

        section img {
            object-fit: contain;
            object-position: bottom;
        }

        .bg-container {
            padding-bottom: 10px;
        }

        section div.content {
            padding-bottom: 150px;
        }
    }
</style>